import { Type } from '@sinclair/typebox';
import { SortOrderSchema } from '../sort-order.js';
import { SupportedNetworkSchema } from '../supported-network.js';
import { LiquidityAddTxSchema } from './liquidity-add-tx.js';
import { LiquidityRemoveTxSchema } from './liquidity-remove-tx.js';
import { LpBurnTxSchema } from './lp-burn-tx.js';
import { PoolInitTxSchema } from './pool-init-tx.js';
import { PoolMigrateTxSchema } from './pool-migrate-tx.js';
import { QuoteBurnTxSchema } from './quote-burn-tx.js';
import { SwapTxSchema } from './swap-tx.js';
export const TxSchema = Type.Union([
    SwapTxSchema,
    LiquidityAddTxSchema,
    LiquidityRemoveTxSchema,
    PoolInitTxSchema,
    PoolMigrateTxSchema,
    LpBurnTxSchema,
    QuoteBurnTxSchema,
]);
export const isSwapTx = (tx) => tx.operation === 'buy' || tx.operation === 'sell';
export const isBuyTx = (tx) => tx.operation === 'buy';
export const GetTxsRequestSchema = Type.Object({
    poolAddress: Type.Optional(Type.String()),
    network: SupportedNetworkSchema,
    sort: SortOrderSchema,
    maker: Type.Optional(Type.Union([Type.String(), Type.Array(Type.String())])),
    minVolumeUsd: Type.Optional(Type.String()),
    minVolumeBase: Type.Optional(Type.String()),
    minVolumeNative: Type.Optional(Type.String()),
    limit: Type.Number({ default: 100, minimum: 1, maximum: 100 }),
    cursor: Type.Optional(Type.String()),
    tokenMeta: Type.Optional(Type.Boolean({ default: false })),
    /**
     * Only trades at or after this moment, in milliseconds.
     *
     * Asking about wallets rather than a pair is answered through the
     * `by_maker` projection, which is ordered `(network, maker, timestamp)`, so
     * a bound on the time prunes inside each wallet's range instead of reading
     * its whole history to sort it. Measured on production 2026-10-03, fifty
     * wallets and a page of thirty: **534ms and 455 MiB with a day's bound,
     * 3,366ms and 2.11 GiB without**.
     */
    since: Type.Optional(Type.Number({ minimum: 0 })),
    swapsOnly: Type.Optional(Type.Boolean({
        default: false,
        description: 'Return only buy/sell operations. For maker queries this enables the wallet-activity index fast path.',
    })),
});
//# sourceMappingURL=tx.js.map